<script setup>
//Тег <video в прелоадере при загрузке страницы
import { onMounted, onUnmounted, computed, ref, inject, watch } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
const props = defineProps({
	fileName: {
		type: String,
		required: true,
		default: ''
	},
	path: {
		type: String,
		required: true,
		default: ''
	},
	webm: {
		type: Boolean,
		required: false,
		default: false
	},
	mp4: {
		type: Boolean,
		required: false,
		default: true
	},
	width: {
		type: Number,
		required: false
	},
	height: {
		type: Number,
		required: false
	},
	loop: {
		type: Boolean,
		default: true,
		required: false
	},
	autoplay: {
		type: Boolean,
		default: true,
		required: false
	},
	thumbVideoPlay: {
		type: Boolean,
		default: false,
		required: false
	}
})
const isLoaded = ref(false)
const videoElement = ref()
const interval = ref()
const ratio = computed(() => {
	let style = {}
	let ratio
	if (props.width && props.height) {
		ratio = (props.height / props.width) * 100
		style.paddingTop = ratio + '%'
	}
	return style
})
const urlToLoad = computed(() => {
	let url = false
	if (store.state.preloader.isReadyToLoad === true && props.mp4) {
		url = new URL('/'+ props.path + '/' + props.fileName + '.mp4', import.meta.url).href
	}
	return url
})
const urlToLoadWebm = computed(() => {
	let url = false
	if (store.state.preloader.isReadyToLoad === true && props.webm) {
		url = new URL('/' + props.path + '/' + props.fileName + '.webm', import.meta.url).href
	}
	return url
})
function handleLoadData() {
	handleSuccessLoad()
}
function addToPreloader() {
	store.commit('preloader/plus')
}

function handleSuccessLoad() {
	isLoaded.value = true
	store.commit('preloader/minus')
	if (props.autoplay === true) {
		videoElement.value.play()
	}

	//console.log(`${urlToLoad.value} ${'%c'} is loaded`, 'background: #222; color: #bada55')
	clearInterval(interval.value)
}
function handleErrorLoad() {
	console.log(`${urlToLoad.value} ${'%c'}is NOT loaded`, 'background: #222;; color: red')
}
onMounted(() => {
	addToPreloader()
})
onUnmounted(() => {
	interval.value = null
})
watch(
	() => props.thumbVideoPlay,
	(thumbVideoPlay) => {
		console.log(thumbVideoPlay)
		if (thumbVideoPlay === true) {
			videoElement.value.play()
			console.log(`pl`)
		} else {
			videoElement.value.pause()
			console.log(`paus`)
		}
	},
	{ immediate: false }
)
</script>

<template>
	<div class="video-box" :style="ratio" :class="[{ withRatio: props.width }, { loaded: isLoaded }]">
		<slot />
		<div class="video-elem-wrap video">
			<video ref="videoElement" @loadeddata="handleLoadData" v-if="store.state.preloader.isReadyToLoad"  muted :loop="props.loop" @error="handleErrorLoad">
				<source v-if="webm" type="video/webm" :src="urlToLoadWebm" />
				<source v-if="mp4" type="video/mp4" :src="urlToLoad" />
				<p>Sorry, your browser does not support the &lt;video&gt; element.</p>
			</video>
		</div>
	</div>
</template>
<style scoped lang="scss"></style>
